import {useEffect} from "react";
import {useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";
import {useToast} from "@hooks";
import { retailer } from "@signals";
import {userDrawerFilters, reloadUserDetailsFilters} from "../../@signals";


export default function useUserDrawer() {

    const { showToast } = useToast()
    const userFormFilters = useSignal({ ...userDrawerFilters.value });
    const isCreateMode = useSignal(false)

    const apiUrl = isCreateMode.value
        ? `${BACKEND_APIS.MANAGEMENT}/customer/user-create`
        : `${BACKEND_APIS.MANAGEMENT}/customer/user-update`

    const handleUserUpdate = () => {
        userFormFilters.value = { ...userFormFilters.value, sitesScopeValues: retailer.value }
        showToast.promise(postSubmit(apiUrl, userFormFilters.value).then(res => {
            reloadUserDetailsFilters.value = true
        }).catch(e => {
            showToast.error(e)
        }), {
            success: 'User updated successfully',
            loading: 'Updating...',
        })
    }

    useEffect(() => {
        userFormFilters.value = { ...userDrawerFilters.value };
        retailer.value = userFormFilters.value?.sitesScopeValues
        isCreateMode.value = !!userFormFilters.value?.createMode
    }, [userDrawerFilters.value])

    return {
        userFormFilters: userFormFilters,
        isCreateMode: isCreateMode.value,
        handleUserUpdate,
        tableTile: isCreateMode.value ? 'Create User for Customer ' + userFormFilters.value?.customerName : 'Edit User'
    }
}